import { decode as base64Decode } from 'base-64';

export function isTokenExpired(token?: string | null, leewaySec = 10): boolean {
	if (!token) return true;

	try {
		const parts = token.split('.');
		if (parts.length !== 3) {
			console.warn('[TokenUtils] Invalid token format - expected 3 parts, got', parts.length);
			return true; // Invalid format
		}

		const [, payloadB64 = ''] = parts;

		if (!payloadB64) {
			console.warn('[TokenUtils] Empty payload');
			return true;
		}

		const b64 = payloadB64
			.replace(/-/g, '+')
			.replace(/_/g, '/')
			.padEnd(Math.ceil(payloadB64.length / 4) * 4, '=');

		// безопасно декодиране и за web, и за RN
		let json: string;
		try {
			json = typeof atob === 'function' ? atob(b64) : base64Decode(b64);
		} catch (decodeError) {
			console.error('[TokenUtils] Base64 decode failed:', decodeError);
			return true;
		}

		let payload: any;
		try {
			payload = JSON.parse(json);
		} catch (parseError) {
			console.error('[TokenUtils] JSON parse failed:', parseError);
			return true;
		}

		const expSec: number | undefined = payload?.exp;
		if (!expSec) {
			console.warn('[TokenUtils] No exp field in token payload');
			return true;
		}

		const nowSec = Math.floor(Date.now() / 1000);
		const isExpired = nowSec >= expSec - leewaySec;

		if (isExpired) {
			console.log('[TokenUtils] Token expired:', {
				now: nowSec,
				exp: expSec,
				diff: expSec - nowSec,
			});
		}

		return isExpired;
	} catch (e) {
		console.error('[TokenUtils] Token validation error:', e);
		return true;
	}
}
